import { render, staticRenderFns } from "./ViewAllMedicationsDialog.vue?vue&type=template&id=63c1c5f8"
import script from "./ViewAllMedicationsDialog.vue?vue&type=script&lang=js"
export * from "./ViewAllMedicationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports